import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { HomeWorkOutlined } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { RoundedBackgroundIcon } from '../../../components/roundedBackgroundIcon';
import { TitleDivider } from '../../../components/titleDivider';
import { PropertyFormStore } from '../../../stores/properties/propertyFormStore';
import { FORM_MAX_WIDTH, propertyTypeOptions } from '../../../utils/constants';
import {
  AsIsValue,
  PropertyAddress,
  PropertyType,
  PurchasePrice,
} from '../components/propertyInformationFields';
import { EditControls } from '../../../components/editControls';
import { RentalPortfolioQuoteStore } from '../../../stores/rentalPortfolioQuoteStore';
import { PortfolioInformationFormStore } from '../../../stores/portfolioInformation/portfolioInformationFormStore';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    position: 'relative',
    maxWidth: 1300,
    margin: 'auto',
  },
}));
interface PropertyInformationFormProps {
  store: PropertyFormStore;
  portfolioInformationStore: PortfolioInformationFormStore;
  onDeleteClick: (propertyKey: string) => void;
  removeButtonDisabled?: boolean;
  showActions: boolean;
  quoteTypeStore: RentalPortfolioQuoteStore;
}

export const RentalPortfolioPropertyInformationForm = observer(
  ({
    store,
    onDeleteClick,
    showActions = true,
    removeButtonDisabled = false,
    quoteTypeStore
  }: PropertyInformationFormProps) => {

    const classes = useStyles();
    const propertyKey = store.form.meta.key;

    function saveHandler() {
      const isValid = store.validateAndCleanupProperty(
        'Please complete all the required fields'
      );
      if (isValid) {
        store.setEditMode(false);
      }
    }

    return (
      <>
        <Grid
          container
          spacing={2}
          className={classes.container}
          style={{ maxWidth: FORM_MAX_WIDTH, marginBottom: '0.5rem' }}
        >
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <RoundedBackgroundIcon
                  Icon={HomeWorkOutlined}
                  iconColor="#6D6D6D"
                />
              </Grid>
              <Grid item>
                <Typography variant="h4" style={{ color: '#6D6D6D' }}>
                  Edit Property
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginTop: '1rem', marginBottom: '1rem' }}
          >
            <TitleDivider title="Property Details" />
          </Grid>
          <Grid item xs={12}>
            <PropertyType store={store} options={propertyTypeOptions} disabled />
          </Grid>
          <Grid item xs={12}>
            <PropertyAddress store={store} quoteTypeStore={quoteTypeStore} />
          </Grid>
        </Grid>
        {showActions && (
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            style={{ padding: '1rem' }}
          >
            <EditControls
              onDeleteClick={() => onDeleteClick(propertyKey)}
              onSaveClick={saveHandler}
              removeButtonDisabled={removeButtonDisabled}
            />
          </Grid>
        )}
      </>
    );
  }
);